import { theme } from 'aimo-ui';
import { PermitElementRow } from 'components/services/PermitElementRow';
import format from 'date-fns/format';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ValidityInfoProps = {
  validFrom: string | undefined;
  validTo: string | undefined;
};

export const PoolingGroupValidityInfo: React.FC<ValidityInfoProps> = ({
  validFrom,
  validTo,
}) => {
  const { t } = useTranslation();
  const formatDate = (date?: string) =>
    date ? format(new Date(date), 'd.M.y') : undefined;
  const [validFromText, validToText] = [validFrom, validTo].map(formatDate);

  return (
    <>
      {['validFrom', 'validTo'].map((type) => {
        const value = type === 'validFrom' ? validFromText : validToText;
        const textColor = value ? theme.colors.black : theme.colors.gray300;

        if (!value) return null;

        return (
          <PermitElementRow
            key={type}
            label={t(`permit.access.${type}`)}
            detail={value ?? t('permit.access.no_data')}
            withTopBorder={true}
            borderColor={'#0A0A0A0A'}
            labelColor={theme.colors.black}
            detailColor={textColor}
          />
        );
      })}
    </>
  );
};
